import { apiRequest } from './client';

export const systemApi = {
  maintenance: () => apiRequest('/api/v1/maintenance', { skipAuth: true, cache: false, timeoutMs: 10000 }),
  saveMaintenance: state => apiRequest('/api/v1/admin/maintenance', { method: 'PUT', body: state }),
};

